/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SkipBackIcon = /*#__PURE__*/ createSvgIcon(
  'SkipBackIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.583 14.167V5.833c0-.236.08-.434.24-.593.16-.16.357-.24.594-.24.236 0 .434.08.593.24.16.16.24.357.24.593v8.334c0 .236-.08.434-.24.593a.806.806 0 01-.593.24.806.806 0 01-.594-.24.806.806 0 01-.24-.593zm9.542-.021l-5.167-3.459a.83.83 0 01-.281-.302.81.81 0 01-.094-.385c0-.139.031-.267.094-.385a.83.83 0 01.281-.303l5.167-3.458a.492.492 0 01.23-.104c.082-.014.159-.02.228-.02.223 0 .417.076.584.228a.78.78 0 01.25.604v6.875a.78.78 0 01-.25.605.836.836 0 01-.584.229 1.4 1.4 0 01-.229-.021.492.492 0 01-.23-.104zm-.375-2.271v-3.75L10.917 10l2.833 1.875z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SkipBackIcon;
